// Client-side mirror of backend/auth/permissions.py. UX-only: the server is the
// authority (team endpoints require supervisor, invite requires admin). Keep this
// matrix in lock-step with the backend.
export type Role = 'admin' | 'supervisor' | 'member' | 'viewer';

export const ROLE_ORDER: Role[] = ['viewer', 'member', 'supervisor', 'admin'];

const ROLE_RANK: Record<Role, number> = { viewer: 0, member: 1, supervisor: 2, admin: 3 };

function rankOf(role: string): number {
  return role in ROLE_RANK ? ROLE_RANK[role as Role] : -1; // unknown = below everything
}

/** True if `role` has at least the rank of `minimum`. */
export function roleAtLeast(role: string, minimum: Role): boolean {
  return rankOf(role) >= ROLE_RANK[minimum];
}

/** Who may grant which role: admin → any; supervisor → up to supervisor; else none. */
export function canAssignRole(actor: string, target: Role): boolean {
  if (actor === 'admin') return true;
  if (actor === 'supervisor') return target === 'supervisor' || target === 'member' || target === 'viewer';
  return false;
}
